import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export function trackEvent(event, meta = {}) {
  api.post("/analytics/event", { event, meta }).catch(() => {});
}

export function useEntitlements() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/entitlements/me");
      setData(data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { ent: data, loading, reload: load };
}
